import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Cdashboard from "../views/Candidate/Cdashboard.vue";
import MillDashboard from "../views/Mill/Mdashboard.vue";
import Payres from "../views/Payrespone.vue";
import UnderConstruction from "../views/UnderConstruction.vue";

const requireAuthCandidate = (to, from, next) => {
  if (!sessionStorage.getItem("id")) {
    next({ name: "Home" });
  } else {
    next();
  }
};

const requireAuthMill = (to, from, next) => {
  if (!sessionStorage.getItem("millId")) {
    next({ name: "Home" });
  } else {
    next();
  }
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/payment",
    name: "Pay",
    component: Payres,
  },
  {
    path: "/underservice",
    name: "UnderConstruction",
    component: UnderConstruction,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Cdashboard,
    redirect: "/overview",
    beforeEnter: requireAuthCandidate,
    children: [
      {
        path: "/overview",
        name: "overview",
        component: () =>
          import(
            /* webpackChunkName: "overview" */ "../views/Candidate/Overview.vue"
          ),
      },
      {
        path: "/application",
        name: "application",
        component: () =>
          import(
            /* webpackChunkName: "application" */ "../views/Candidate/Application.vue"
          ),
      },
      {
        path: "/subscription",
        name: "subscription",
        component: () =>
          import(
            /* webpackChunkName: "subscription" */ "../views/Candidate/Subscription.vue"
          ),
      },
    ],
  },
  {
    path: "/MillDashborad",
    name: "MillDashboard",
    component: MillDashboard,
    redirect: "/MillOverview",
    beforeEnter: requireAuthMill,
    children: [
      {
        path: "/MillOverview",
        name: "MillOverview",
        component: () =>
          import(
            /* webpackChunkName: "overview" */ "../views/Mill/MillOverview.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
